import PublicBurger from './PublicBurger';
export default PublicBurger;
